import { CONST_ROOT_FOLDER, CONST_ROOT_NAME } from '../utils/constants'
import { useBibliotecaQueries } from './use-biblioteca-queries'

export const useBibliotecaFolderActions = () => {
  const {
    itemsPorPasta = [],
    getPasta = {},
    loadingPasta,
    loadingItemsPorPasta
  } = useBibliotecaQueries() ?? {}

  const {
    pasta = {
      id: CONST_ROOT_FOLDER,
      nome: CONST_ROOT_NAME,
      breadcrumb: [],
      permissoesAcessoUsuarioLogado: [{ description: '', id: '' }]
    }
  } = getPasta

  const pastasOptions = [
    { value: pasta?.id, label: pasta?.nome },
    ...(itemsPorPasta ?? [])
      .filter(({ pasta: pastaFilter }) => pastaFilter)
      .map(({ id, nome }) => ({ value: id, label: nome }))
  ]

  const hasItems = itemsPorPasta && itemsPorPasta.length > 0

  return {
    itemsPorPasta,
    loadingItemsPorPasta,
    pasta,
    loadingPasta,
    pastasOptions,
    hasItems
  }
}
